import { render } from "./CarruselOfertas.vue?vue&type=template&id=4034ea4e&scoped=true"
import script from "./CarruselOfertas.vue?vue&type=script&lang=js"
export * from "./CarruselOfertas.vue?vue&type=script&lang=js"

import "./CarruselOfertas.vue?vue&type=style&index=0&id=4034ea4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4034ea4e"]])

export default __exports__